import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  age: '52 años',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  text: 'Pensé que a mis 52 años ya era tarde. En 4 días noté la diferencia. En 2 semanas, mi pareja me preguntó qué había cambiado. No le dije el método, solo sonreí.'
}, {
  name: 'Roberto V.',
  age: '45 años',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  text: 'Llevaba meses dependiendo de la pastilla azul y los dolores de cabeza me estaban matando. Este protocolo me devolvió la confianza natural que creí haber perdido para siempre.'
}, {
  name: 'Javier S.',
  age: '58 años',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  text: 'Lo que más valoro es la discreción. Lo hago en mi cuarto en 7 minutos y nadie se entera. Los resultados son innegables, mi esposa está encantada y yo me siento de 30 otra vez.'
}, {
  name: 'Miguel A.',
  age: '41 años',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
  text: 'La ansiedad de ejecución me estaba destruyendo. El método de respiración de emergencia es oro puro. Me calmó instantáneamente la primera vez que lo usé. 100% recomendado.'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4" data-id="element-278">
      <div className="max-w-6xl mx-auto" data-id="element-279">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-280">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-900 border border-slate-800 p-6 rounded-2xl flex flex-col sm:flex-row gap-6 items-center sm:items-start text-center sm:text-left" data-id="element-281">
              <img src={t.image} alt={t.name} width={80} height={80} loading="lazy" decoding="async" className="w-20 h-20 rounded-full object-cover border-2 border-blue-500/50 shrink-0" data-id="element-282" />
              <div data-id="element-283">
                <div className="flex justify-center sm:justify-start gap-1 mb-2" data-id="element-284">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-amber-500 text-amber-500" data-id="element-285" />)}
                </div>
                <p className="text-slate-300 italic mb-4 text-sm leading-relaxed" data-id="element-286">
                  "{t.text}"
                </p>
                <p className="text-white font-bold" data-id="element-287">
                  {t.name},{' '}
                  <span className="text-slate-400 font-normal" data-id="element-288">{t.age}</span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}